import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DepotService {
  protected endpoint: string;

  constructor(private apiService: ApiService) {
    this.endpoint = 'rate-manager/provider/depots';
  }

  /**
   * Removes null or undefined values from the payload before sending to API
   */
  private cleanPayload(rawPayload: any) {
    return Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, v]) => v !== null && v !== undefined
      )
    );
  }

  /**
   * GET: Fetch all depots
   */
  getDepots(payload: Record<string, any> = {}) {
    const cleanedPayload = this.cleanPayload(payload);
    return this.apiService.get(this.endpoint, cleanedPayload, true);
  }

  /**
   * POST: Create a new depot
   */
  async createDepot(payload: Record<string, any>) {
    const cleanedPayload = this.cleanPayload(payload);
    const response: any = await firstValueFrom(
      this.apiService.post(this.endpoint, cleanedPayload, true)
    );
    return response;
  }

  /**
   * PUT: Update an existing depot
   * @param id The depot ID
   * @param payload The updated depot data
   */
  async updateDepot(id: number, payload: Record<string, any>) {
    const cleanedPayload = this.cleanPayload(payload);
    const response: any = await firstValueFrom(
      this.apiService.put(`${this.endpoint}/${id}`, cleanedPayload, true)
    );
    return response;
  }

  /**
   * DELETE: Remove a depot
   * @param id The depot ID
   */
  async deleteDepot(id: number) {
    const response: any = await firstValueFrom(
      this.apiService.delete(`${this.endpoint}/${id}`, {}, true)
    );
    return response;
  }
}
